import { render, staticRenderFns } from "./resolutionTimeCriticality.vue?vue&type=template&id=5344445e&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./resolutionTimeCriticality.vue?vue&type=style&index=0&id=5344445e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344445e",
  null
  
)

export default component.exports